import { useRouterParams } from "@zapier/shared";

export enum EmptyAppsTable {
  EmptySearchResults = "EmptySearchResults",
  NoApps = "NoApps",
}

interface Input {
  isLoading?: boolean;
  hasNoApps?: boolean;
}

export function useShowEmptyAppsTable({ isLoading, hasNoApps }: Input) {
  const { search } = useRouterParams();

  const isSearch = !!search;

  /* Empty Search */
  if (isSearch && hasNoApps && !isLoading) {
    return EmptyAppsTable.EmptySearchResults;
  }

  /* Empty List */
  if (!isSearch && hasNoApps && !isLoading) {
    return EmptyAppsTable.NoApps;
  }

  return;
}
